module.exports = __webpack_public_path__ + "img/core-bg2.a591f8b3.png";